type Params = {
  bt_env?: "stage" | "prod";
  ignore_cache?: boolean;
  preview?: boolean;
};

const QUERY_PARAMS = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => {
    const value = searchParams.get(prop as string);
    if (value === "true") return true;
    if (value === "false") return false;
    return value;
  },
}) as unknown as Params;

export const BT_ENV = QUERY_PARAMS.bt_env || "prod";
export const RL_PREVIEW = QUERY_PARAMS.preview ?? false;
